import ClientRepository from "@domain/repositories/ClientRepository";
import UseCase from "@domain/UseCase";
import { Client } from "@domain/models/Client";

type Input = {
  clientId: Client["id"];
  data: Partial<Client>;
};

type Output = Promise<Client>;

export class UpdateClientUseCase implements UseCase<Input, Output> {
  constructor(private readonly clientRepository: ClientRepository) {}

  async execute({ clientId, data }: Input) {
    return this.clientRepository.save(clientId, data);
  }
}
